<template lang="pug">
.information-contents
    .informations
        .information.information-content(v-for="content in information.contents")
            .title-bar
                label
                    span {{ information.position }}.
                    | &nbsp; {{ $t('Insertion') }}
                .actions
                    el-button(
                        v-if="information.deleted"
                        circle
                        size="mini"
                        type="info"
                        icon="el-icon-fa-trash-restore fas"
                        @click="restoreInformation"
                    )
                    el-button(
                        v-else
                        circle
                        size="mini"
                        type="danger"
                        icon="el-icon-fa-trash-alt far"
                        @click="removeInformation"
                    )
            input-content(
                v-if="content.key == 'information-content'"
                :key="content.id"
                :section="information"
                :content="content"
                :config="getConfig(content.key)"
                :options="options"
                :section-setting-values="sectionSettingValues"
                :edit="edit"
            )
            image-content(
                v-else-if="content.key == 'information-image'"
                :section="information"
                :content="content"
                :config="getConfig(content.key)"
                :options="options"
                :section-setting-values="sectionSettingValues"
                :edit="edit"
            )
    .reactions
        Reaction(
            v-if="edit"
            v-for="reaction in information.reactions"
            :key="reaction.id"
            :section="section"
            :reaction="reaction"
            :information="information"
            :options="options"
            :section-setting-values="sectionSettingValues"
            :config="config"
            :edit="edit"
        )
    .reaction-actions
        el-button.section-option.add-reaction(
            type="success"
            size="mini"
            @click.stop="addReaction('text')"
            icon="el-icon-fa-pen fas"
            title="Eingabefeld"
        )
        el-button.section-option.add-reaction(
            type="success"
            size="mini"
            @click.stop="addReaction('radio')"
            icon="el-icon-fa-check fas"
            title="Ja/Nein"
        )
        el-button.section-option.add-reaction(
            type="success"
            size="mini"
            @click.stop="addReaction('select')"
            icon="el-icon-fa-tasks fas"
            title="Multiple Choice"
        )
        el-button.section-option.add-reaction(
            type="success"
            size="mini"
            @click.stop="addReaction('nextInformation')"
            icon="el-icon-fa-random fas"
            title="Nächste Einblendung"
        )
</template>

<i18n>
{
    "de": {
        "Insertion": "Einblendung"
    }
}
</i18n>

<script>
import uniqid from 'uniqid';

import store from '@/store'
// import InputContent from './Partials/InformationInputContent'
// import ImageContent from './Partials/ImageContent'

import { addContentToSection } from '@/helpers'

import InputContent from '@/components/Page/Sections/Partials/InputContent'
import ImageContent from '@/components/Page/Sections/Partials/ImageContent'

import Reaction from './Reaction'

export default {
    name: 'Information',
    components: {
        InputContent,
        ImageContent,
        Reaction
    },
    props: {
        information: {
            type: Object,
            required: true
        },
        section: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        },
        edit: {
            type: Boolean,
            required: true
        },

        sectionSettingValues: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    methods: {
        getConfig(key) {
            const contents = this.config.contents || []
            return contents.find(config => config.key === key)
        },
        addReaction(type = 'text', position = undefined) {
            // const section = this.section

            const reactions = _.get(this.information, 'reactions');
            if (reactions === undefined) this.$set(this.information, 'reactions', []);

            if (position === undefined) position = this.information.reactions.length + 1;

            const reaction = {
                id: uniqid('new:'),
                position,
                contents: [],
                // initialPosition: informations.length
                __typename: type,
            };

            let configs = _.get(this.config, 'contents') || [];
            configs = configs.filter(el => el.scope === 'reaction');

            if (configs.length) {
                configs
                    .sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
                    .forEach(config => {
                        let content = {
                            id: uniqid('new:'),
                            key: config.key,
                        };

                        addContentToSection(reaction, config, content)
                    });
            }

            this.$set(this.information.reactions, this.information.reactions.length, reaction);
        },
        removeInformation() {
            const section = this.section
            // store.commit(`${this.module}/form/markInformationAsDeleted`, { i: this.i, s: this.s, inf: this.inf })

            const i = section.informations.findIndex(el => el.id === this.information.id)
            this.$delete(this.section.informations, i);
        },
        restoreInformation() {
            // store.commit(`${this.module}/form/unmarkInformationAsDeleted`, { i: this.i, s: this.s, inf: this.inf })
        },
    },
}
</script>

<style lang="sass" scoped>
.title-bar
    display: flex
    label
        flex-grow: 1
        font-size: 14px
        margin-bottom: 1rem
        display: block
        span
            font-size: 1.4rem
.informations,
.reactions
    width: 60%
    background-color: $color-body
    padding: 15px
    border-radius: 4px
    margin-bottom: 1.2rem

.information-contents
    display: flex
    flex-direction: column
    .reaction-actions
        align-self: flex-end

.information-content
    width: 100%
    margin-bottom: -1.2rem

// .add-reaction
//     float: right
//     margin: 0 5px

.reactions
    display: flex
    align-self: flex-end
    flex-direction: column
    align-items: space-between
    justify-content: space-around
</style>
